




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const JOBPOSTGETALL= createAsyncThunk(
  "JobPostGetAll/JobPostGetAll",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const JobPostGetAllSlice = createSlice({
  name: "JobPostGetAllSlice",
  initialState: {
    JobPostGetAll: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfJobPostGetAll: (state) => {
        state.JobPostGetAll.loading = false
        state.JobPostGetAll.error = false
        state.JobPostGetAll.data = []
        state.JobPostGetAll.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(JOBPOSTGETALL.fulfilled, (state, action) => {
      state.JobPostGetAll = {
        ...state.JobPostGetAll,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(JOBPOSTGETALL.pending, (state, action) => {
      state.JobPostGetAll = {
        ...state.JobPostGetAll,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(JOBPOSTGETALL.rejected, (state, action) => {
      state.JobPostGetAll = {
        ...state.JobPostGetAll,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const JobPostGetAllAction = {
    JOBPOSTGETALL,
};

export { JobPostGetAllAction };
export default JobPostGetAllSlice.reducer;
export const {setInitialStateOfJobPostGetAll} = JobPostGetAllSlice.actions
